<template>
  <div class="home">
    <div v-if="type">
      <el-button :type="type" @click="prepareChangePw">變更密碼</el-button>
    </div>
    <span v-else @click="prepareChangePw">變更密碼</span>
    <el-dialog title="變更密碼" :visible.sync="resetPwForm.show" :append-to-body="true">
      <el-form :model="resetPwForm" :rules="rules" ref="resetPwForm">
        <el-form-item prop="pw1" label="Password" :label-width="resetPwForm.width">
          <el-input v-model="resetPwForm.pw1" type="password"></el-input>
        </el-form-item>
        <el-form-item prop="pw2" label="再次輸入" :label-width="resetPwForm.width">
          <el-input v-model="resetPwForm.pw2" type="password"></el-input>
        </el-form-item>
        <span>{{ this.resetPwForm.checkMsg }}</span>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetPwForm.show=false">取 消</el-button>
        <el-button type="primary" @click="submitNewPw" :disabled="!canChangePw">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {accountPasswordEdit} from "@/api";

export default {
  name: 'Main',
  props: ['eid', 'type'],
  components: {},
  data() {
    return {
      resetPwForm: {show: false, pw1: '', pw2: '', checkMsg: '', width: '120px'},
      rules: {
        pw1: [
          {required: true, message: '请输入密碼', trigger: 'change'},
          {min: 3, max: 10, message: '長度在 3 到 10 個字母', trigger: 'change'}
        ],
        pw2: [
          {required: true, message: '再次輸入密碼', trigger: 'change'},
          {min: 3, max: 10, message: '長度在 3 到 10 個字母', trigger: 'change'}
        ],
      }
    }
  },
  computed: {
    canChangePw() {
      const {pw1, pw2} = this.resetPwForm
      return this.pwIsValid(pw1, pw2)
    }
  },
  watch: {
    resetPwForm: {
      handler(newVal, oldVal) {
        const {pw1, pw2} = newVal
        console.log(newVal);
        let result = ''
        if (pw1 && pw2) {
          if (this.pwIsValid(pw1, pw2)) {
            result = ''
          } else {
            result = '密碼不同'
          }
        }
        this.resetPwForm.checkMsg = result
      },
      deep: true
    }
  },
  methods: {
    pwIsValid(pw1, pw2) {
      return (pw1 === pw2) && (pw1 !== '')
    },
    submitNewPw() {
      this.$refs['resetPwForm'].validate(valid => {
        if (valid) {
          if (this.resetPwForm.pw1 !== '' && this.resetPwForm.pw1 === this.resetPwForm.pw2) {
            const EID = this.eid ? this.eid : 0
            accountPasswordEdit({EID, PWD: this.resetPwForm.pw1})
                .then(({RES}) => {
                  if (RES) {
                    this.hideResetForm()
                    this.$message.success('密碼變更成功')
                  } else {
                    this.$message.error('密碼變更失敗')
                  }
                })
                .catch(reason => {
                  this.$message.error(reason)
                })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    hideResetForm() {
      this.resetPwForm.show = false
    },
    resetFormData() {
      this.resetPwForm.show = true
      this.resetPwForm.locked = false
      this.resetPwForm.pw1 = ''
      this.resetPwForm.pw2 = ''
      this.resetPwForm.checkMsg = ''
    },
    prepareChangePw() {
      this.resetFormData()
      this.resetPwForm.show = true
    }
  },
  created() {
  }
}
</script>
<style scoped>
</style>
